$.fn.thermometer = function(options) {
  let self = this
  moveThermometer();

  $(window).scroll(function(){
    moveThermometer();
 });

 function moveThermometer() {
   //Push thermometer to stay over footer
   var offset = 40;
   var thermo_bottom = self.offset().top + self.outerHeight();
   var footer_top = $('.footer').offset().top;
   if (thermo_bottom > footer_top - offset) {
     self.css('--push-bottom', ((thermo_bottom - footer_top + offset) * -1) + 'px');
   } else {
     self.css('--push-bottom', '0px');
   }

   //Move pointer
   var page_height = $(document).height();
   var window_height = $(window).height();
   var scroll_positon = $(window).scrollTop();
   var percentage = scroll_positon * 100 / (page_height - window_height);
   self.css('--top', percentage + '%');
   element_to_select = parseInt(percentage * 9 / 100);
   if (element_to_select > 8) {element_to_select = 8}
   self.find('.thermometer__ruler-numbers__item').removeClass('selected');
   self.find('.thermometer__ruler-numbers__item').eq(element_to_select).addClass('selected');
 }

  return function() {
    return self
  }()
}
